import { FIND_TRANSACTION} from "../../routes";
import customAxios from "../../customAxios";
import {  IFindTransaction } from "../../../types/common.interface";

async function findTransaction(props: IFindTransaction) {
  var thisUrl = FIND_TRANSACTION;
  let page= 1;
  let limit= 10;
  if (props.page) page=props.page;
  if (props.limit) limit=props.limit;

  const populate: string = 'driver parent student'

  let body: any = {
   ...props, page, limit, populate,
  };

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({FIND_TRANSACTION: error});
  }
}

export default findTransaction;
